/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.PAGEHEADING,
    label: "Create a Department of Education account"
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.TEXT.FIELDHEADING,
    label: "Enter your personal details"
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "firstName",
    label: "First name",
    hint: "The name you provide must match the name on your identity documents.",
    fieldRequired: true,
    validation: { required: true, regex: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/ }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "middleName",
    label: "Middle name (optional)",
    hint: "The name you provide must match the name on your identity documents.",
    validation: { regex: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/ }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "lastName",
    label: "Last name",
    hint: "The name you provide must match the name on your identity documents.",
    fieldRequired: true,
    validation: { required: true, regex: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/ }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "preferredName",
    label: "Preferred first name (optional)",
    hint: "The department will use your preferred name in any communications to you."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "dateOfBirth",
    label: "Date of birth",
    hint: "Your date of birth must match your identity documents.",
    validation: { required: true },
    fromYear: 1900,
    toYear: new Date().getFullYear() - 18
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "email",
    type: "email",
    label: "Personal email address",
    hint: "Enter your personal (not shared) email address. This must be an email address only you use, not one shared by multiple people.",
    fieldRequired: true,
    validation: { required: true, email: true, regex: /@(?!det.nsw.edu.au)/ }
  },
  {
    fieldType: FIELD.INPUT.TEXTCONFIRMATION,
    name: "emailConfirmation",
    label: "Personal email address",
    hint: "Re-enter your personal email address.",
    comparisonGetter: "getRegistrationEmail",
    fieldRequired: true,
    validation: { required: true, email: true, regex: /@(?!det.nsw.edu.au)/, confirmed: 'comparisonField' }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "mobile",
    label: "Mobile number (required)",
    hint: "Enter your personal (not shared) mobile number. This may be used to recover your account details.",
    validation: { required: true, min:10, regex: /^0[45]\d{8}$/ }

  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmWwcc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: "I confirm I have a valid Working with Children Check."
      }
    ]
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmDoePolicies",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: "I confirm that I have read the below statement and will adhere to cyber security safety protocols."
      }
    ]
  },
  {
    fieldType: FIELD.TEXT.PARAGRAPH,
    label: "confirmDoePrivacy",
    description: "The personal information collected on this application is for purposes directly related to creating a NSW Department of Education (DoE) login account in your name, sending you your DoE account information and the use of this application, including allowing you to reset your password in the future. Any information provided to the NSW Department of Education will be used, disclosed and stored consistent with NSW privacy laws. Provision of this information is voluntary, however without this information access to the required services cannot be provided to you by the NSW Department of Education."
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.FORM.ACTIONS,
    buttons: [
      {
        label: "Previous",
        size: "large",
        appearance: "secondary",
        prefix: "chevronLeft",
        action: "form:previous",
        skippable: true
      },
      {
        label: "Next",
        size: "large",
        appearance: "primary",
        suffix: "chevronRight",
        action: "form:next"
      }
    ]
  }
];